<template>
    <div class="categories">
        <h2 class="categories__header">
            {{ $page.props.settings.translations.blog.categories }}
        </h2>

        <div class="categories__buttons">
            <a
                v-for="category in categories"
                :key="category.id"
                :href="`#${category.slug}`"
                class="categories__button"
            >
                {{ category.name }}
            </a>
        </div>

        <div class="categories__list">
            <div
                v-for="category in categories"
                :key="category.id"
            >
                <h2
                    :id="category.slug"
                    class="categories__article-title"
                >
                    {{ category.name }}
                </h2>

                <Category :articles="category.articles" />
            </div>
        </div>
    </div>
</template>

<script setup>
import Category from '../category/watson-theme-category.vue';

defineProps({
    categories: {
        type: Array,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-categories";
</style>
